<template>
  <div class="mt-6">
    <h4
      v-if="showSingleHeading"
      class="text-lg font-normal mb-3 lg:max-w-500"
    >
      {{ recipeSuggestions[0].heading }}
    </h4>
    <div
      ref="swiperContainer"
      class="swiper-container overflow-visible"
    >
      <div class="swiper-wrapper">
        <div
          v-for="(suggestion, index) in recipeSuggestions"
          :key="index"
          class="swiper-slide lg:max-w-500"
        >
          <div class="flex flex-col h-full">
            <h4
              v-if="!showSingleHeading"
              class="text-lg font-normal mb-3"
            >
              {{ suggestion.heading }}
            </h4>
            <div class="flex-1 flex items-end">
              <a
                :href="suggestion.recipe.url"
                class="theme theme-blue-grey p-4 rounded flex w-full h-full"
                @click="onItemClick(suggestion.recipe.title)"
              >
                <div class="flex items-center rtl:flex-row-reverse">
                  <div class="c-recipe-suggestions flex-shrink-0 ltr:mr-3 rtl:ml-3">
                    <Picture
                      v-if="suggestion.recipe.image"
                      v-bind="suggestion.recipe.image"
                      :mobile="[132, 88]"
                      width="132"
                      height="88"
                      img-class="block rounded object-cover w-full h-full"
                      :alt="suggestion.recipe.title"
                    />
                  </div>
                  <div>
                    <span class="text-2xs">{{ suggestion.recipe.cookingTimeText }}</span>
                    <h4 class="text-large font-normal">{{ suggestion.recipe.title }}</h4>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Picture from '@/components/Picture.vue'
import Swiper from 'swiper/swiper-bundle'

export default {
  components: {
    Picture
  },
  props: {
    recipeSuggestions: {
      type: Array,
      required: true
    }
  },
  computed: {
    showSingleHeading() {
      if (!this.recipeSuggestions.length) {
        return false
      }
      const headings = this.recipeSuggestions.map((r) => r.heading).filter(Boolean)
      return headings.length === 1 && !!this.recipeSuggestions[0].heading
    }
  },
  mounted() {
    this.swiper = new Swiper(this.$refs.swiperContainer, {
      slidesPerView: 1.3,
      spaceBetween: 16,
      loop: false,
      breakpoints: {
        1024: {
          slidesPerView: 2.2
        },
        1536: {
          slidesPerView: 3.2
        }
      }
    })
  },
  methods: {
    onItemClick(relatedRecipeTitle) {
      const trackingData = {
        event: 'recipeActionServingSuggestion',
        relatedRecipeTitle
      }
      if (window.dataLayer) {
        window.dataLayer.push(trackingData)
      }
    }
  }
}
</script>
